export const ChevronLeftSVG = (props) => (
  <svg height={18} viewBox="0 0 10 18" width={10} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.96 16.859l-3.675-3.675L.96 8.859l8-8" fill="none" stroke="#000" strokeLinecap="square" {...props?.pathProps} />
  </svg>
);
